import React, { Suspense, lazy } from 'react';

import { Container } from '@/components/ui';
import { LandingHero, VideoGrid } from '@/components/landing';
import { demos } from '@/data/demos';
import { useDelayedRender } from '@/hooks/use-delayed-render';
import { NoSSR } from '@/components/no-ssr';

// Lazy-load the heavy Skia animation component
const SpiralHandler = lazy(() =>
  import('@/components/animated-spiral').then((mod) => ({
    default: mod.SpiralHandler,
  }))
);

const RENDER_SPIRAL_DELAYED_CONFIG = {
  delay: 200,
  mobileOnly: false,
};

const getIsLowEndDevice = () => {
  const memory =
    (navigator as Navigator & { deviceMemory?: number }).deviceMemory ?? 8;
  const cores = navigator.hardwareConcurrency ?? 4;
  return memory < 4 || cores < 4;
};

const AnimatedSpiral = () => {
  const shouldRenderSpiral = useDelayedRender(RENDER_SPIRAL_DELAYED_CONFIG);

  if (!shouldRenderSpiral || getIsLowEndDevice()) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <SpiralHandler />
    </Suspense>
  );
};

const DemosPage = React.memo(() => {
  return (
    <Container size="xl" className="mt-4 sm:mt-0">
      <NoSSR>
        <div
          className="w-full absolute left-0 -z-10"
          style={{
            top: -window.innerHeight * 0.15,
            height: 500,
          }}
        >
          <AnimatedSpiral />
        </div>
      </NoSSR>
      <div className="space-y-8 sm:space-y-8 lg:space-y-12">
        <LandingHero />
        <VideoGrid demos={demos} />
      </div>
    </Container>
  );
});

export default DemosPage;
